"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
exports.default = {
    selectFilter: {
        datapoint: {
            name: 'TnS_SelectFilter',
            options: { enablePerformanceMarks: true },
            customData: function (viewFilter, actionSource) { return [
                viewFilter,
                actionSource,
            ]; },
        },
    },
    selectSort: {
        datapoint: {
            name: 'TnS_MailListSelectSort',
            customData: function (sortColumn, sortDirection, tableView, actionSource) { return [
                sortColumn,
                sortDirection,
                actionSource,
                tableView.totalRowsInView,
                folderIdToName_1.default(tableView.tableQuery.folderId),
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-filter-actions/lib/datapoints.js
// module id = 1848
// module chunks = 46 105